/**
 * Плавне розкриття будь-якого блоку (owner 2026-09-12: «розкривається жорстко,
 * треба плавно; і щоб нові розділи це підхоплювали самі»).
 *
 * Чому сітка, а не max-height: `height: auto` анімувати не можна, а фіксована
 * max-height або ріже довгий вміст, або дає «стрибок» у кінці. Трюк
 * `grid-template-rows: 0fr → 1fr` анімує САМЕ фактичну висоту вмісту.
 *
 * Використання замість `{open && <div>…</div>}`:
 *   <Collapse open={open}><div className="p-4">…</div></Collapse>
 *
 * Вміст лишається в DOM, тому всередині не варто тримати важкі списки —
 * для них краще умовний рендер.
 */
export function Collapse({
  open,
  children,
  className = "",
}: {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={"grid " + className}
      style={{
        gridTemplateRows: open ? "1fr" : "0fr",
        transition: "grid-template-rows var(--dur) var(--ease-ios)",
      }}
      aria-hidden={!open}
    >
      <div className="overflow-hidden">{children}</div>
    </div>
  );
}
